import { Component } from 'react'
import './ErrorBoundary.css'

// Catches render-time errors anywhere below it so a single uncaught
// exception (e.g. a missing null-check on first render, before async data
// has loaded) shows a recoverable screen instead of silently unmounting
// the whole tree to a blank page. Mirrors Prod's ErrorBoundary.jsx contract
// exactly (same class shape, same fallback copy) for a drop-in merge.
export default class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Render error caught by ErrorBoundary:', error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="error-boundary">
        <h1>Something went wrong</h1>
        <p>This page hit an unexpected error. Reloading usually fixes it — if it keeps happening, let us know what you were doing.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload Page
        </button>
      </div>
    )
  }
}
